import React, { useMemo, useState } from "react";

import { data as fmtData, reais } from "./formato";

// Barras por dia: série principal cheia e a secundária sobreposta (ex.: faturado × desconto).
// Períodos longos agrupam por semana pra continuar legível.
export default function GraficoDias({ serie, principal, secundaria, titulo, legenda, corPrincipal = "bg-sky-500", corSecundaria = "bg-amber-400", formatar = reais }) {
  const [foco, setFoco] = useState(null);
  const pontos = useMemo(() => {
    const lista = serie || [];
    if (lista.length <= 62) return lista.map((d) => ({ ...d, rotulo: fmtData(d.dia).slice(0, 5) }));
    const semanas = [];
    for (let i = 0; i < lista.length; i += 7) {
      const bloco = lista.slice(i, i + 7);
      const soma = (campo) => bloco.reduce((s, d) => s + Number(d[campo] || 0), 0);
      semanas.push({ dia: bloco[0].dia, rotulo: `sem. ${fmtData(bloco[0].dia).slice(0, 5)}`, [principal]: soma(principal), ...(secundaria ? { [secundaria]: soma(secundaria) } : {}) });
    }
    return semanas;
  }, [serie, principal, secundaria]);
  const maximo = Math.max(1, ...pontos.map((p) => Number(p[principal] || 0)), ...(secundaria ? pontos.map((p) => Number(p[secundaria] || 0)) : []));
  const atual = foco != null ? pontos[foco] : null;
  const total = pontos.reduce((s, p) => s + Number(p[principal] || 0), 0);
  return (
    <section className="rounded-xl border bg-card p-4 sm:p-5">
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-3">
        <h3 className="font-semibold">{titulo}</h3>
        <div className="flex items-center gap-3 text-[11px] text-muted-foreground">
          {legenda.map((l) => <span key={l.rotulo} className="flex items-center gap-1"><span className={`w-2.5 h-2.5 rounded-sm ${l.cor}`} />{l.rotulo}</span>)}
        </div>
      </div>
      <p className="text-xs text-muted-foreground mb-2 min-h-[1rem] tabular-nums">
        {atual ? <><b className="text-foreground">{atual.rotulo}</b> · {legenda[0].rotulo}: {formatar(atual[principal])}{secundaria ? ` · ${legenda[1].rotulo}: ${formatar(atual[secundaria])}` : ""}</>
          : total === 0 ? "Sem movimento no período." : "Passe o dedo ou o mouse nas barras."}
      </p>
      <div className="flex items-end gap-[2px] h-32" onMouseLeave={() => setFoco(null)}>
        {pontos.map((p, i) => (
          <div key={p.dia} className="relative flex-1 h-full flex items-end min-w-[3px] cursor-default" onMouseEnter={() => setFoco(i)} onTouchStart={() => setFoco(i)}>
            <div className={`w-full rounded-t ${corPrincipal} ${foco === i ? "opacity-100" : "opacity-80"}`} style={{ height: `${(Number(p[principal] || 0) / maximo) * 100}%`, minHeight: Number(p[principal]) > 0 ? 2 : 0 }} />
            {secundaria && Number(p[secundaria]) > 0 && (
              <div className={`absolute bottom-0 left-1/4 w-1/2 rounded-t ${corSecundaria}`} style={{ height: `${(Number(p[secundaria]) / maximo) * 100}%` }} />
            )}
          </div>
        ))}
      </div>
      {pontos.length > 0 && (
        <div className="flex justify-between text-[10px] text-muted-foreground mt-1 tabular-nums">
          <span>{pontos[0].rotulo}</span><span>{pontos[pontos.length - 1].rotulo}</span>
        </div>
      )}
    </section>
  );
}
